import React from 'react';
import { Home, Check } from 'lucide-react';
import { cn } from '@/infra/utils';

interface LogoProps {
  className?: string;
  iconOnly?: boolean;
  variant?: 'light' | 'dark';
}

export function Logo({ className, iconOnly = false, variant = 'light' }: LogoProps) {
  const isDark = variant === 'dark';
  
  return (
    <div className={cn("flex items-center gap-2 select-none", className)}>
      <div className="relative flex items-center justify-center w-10 h-10 bg-emerald-600 rounded-xl shadow-lg shadow-emerald-900/20 group transition-transform hover:scale-105">
        <Home className="w-6 h-6 text-white" />
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-white rounded-full flex items-center justify-center shadow-sm border border-emerald-100">
          <Check className="w-2.5 h-2.5 text-emerald-600 stroke-[4px]" />
        </div>
      </div>
      
      {!iconOnly && (
        <div className="flex flex-col leading-none">
          <span className={cn(
            "text-xl font-black tracking-tighter",
            isDark ? "text-slate-900" : "text-white"
          )}>
            <span className="text-emerald-500">Pro</span>
            Wycena
          </span>
          <span className={cn(
            "text-[8px] uppercase font-bold tracking-[0.2em] opacity-50",
            isDark ? "text-slate-500" : "text-emerald-100"
          )}>
            Inteligentna Budowa
          </span>
        </div>
      )}
    </div>
  );
}
